// extracted by mini-css-extract-plugin
module.exports = {"root":"Paper_root__TSgTA","colorful":"Paper_colorful__mkhGH"};